import {React,useEffect} from 'react';
import vid from './assets/CoviHack Page assets/tech.mp4';
import Hack_o_relay from './assets/CoviHack Page assets/Hack-o-relay-removebg-preview.png';
import './assets/css/Covihack_header.css';
import AOS from "aos";
import "aos/dist/aos.css";
const Covihack_Header=()=>{
    useEffect(() => {
        AOS.init();
        AOS.refresh();
        
      }, []);
    
    return(
        <div className="coviheader">
             <video autoPlay loop muted playsInline style={{width:"100%",top:"0"}}>
                <source src={vid} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
           
            <div className="coviheader-text">
                <h2>GDSC DCE Presents</h2>
                <h1 data-aos="fade-up">Hack-o-Relay</h1>
                <h3>26th May, 2022 to 28th May, 2022</h3>
                {/* <a href="https://docs.google.com/forms/d/e/1FAIpQLSctJOn7QJnGbSpzTisjcs6s270Yut026KQUxYXD8TMYANIKMw/viewform">Register now!</a> */}
                {/* <a className="disabled">Registration Closed Now</a> */}
                <div className="resizeButton">
                <a href='https://forms.gle/A1VEv6XQrzUsiQNT9' className='registerBtn' target='_blank'>Submission form for track - 3 - Development</a>
                </div>
            </div>
            <img src={Hack_o_relay} alt="covihack"  className="covi-logo"/>
        </div>
    );
}
export default Covihack_Header;